import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=e0cbf8e4&scoped=true&"
import script from "./OrderInfo.vue?vue&type=script&lang=js&"
export * from "./OrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=e0cbf8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cbf8e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0cbf8e4')) {
      api.createRecord('e0cbf8e4', component.options)
    } else {
      api.reload('e0cbf8e4', component.options)
    }
    module.hot.accept("./OrderInfo.vue?vue&type=template&id=e0cbf8e4&scoped=true&", function () {
      api.rerender('e0cbf8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/OrderInfo.vue"
export default component.exports